import { Component, EventEmitter, Input, Output } from '@angular/core';
import {CommonModule} from '@angular/common';
import {VehicleBrand} from '../../../../domain/core/vehicle-brand.model';
import {CheckboxIconComponent} from '../../../../shared/components/checkbox-icon/checkbox-icon.component';
import {CustomerClientRequest} from '../../../../domain/data/customer-client-request.data';
import {ContactEvent, CustomerClientResponse} from '../../../../domain/data/customer-client-response.data';
import {ConsentStatus} from '../../../../domain/data/consent-status';

type ContactChannelsKeys = keyof Pick<CustomerClientRequest, 'messenger' | 'post' | 'phone' | 'email'>;

@Component({
    selector: 'app-contact-channels',
    templateUrl: './contact-channels.component.html',
    imports: [
        CommonModule,
        CheckboxIconComponent,
    ]
})
export class ContactChannelsComponent {
  @Input() customerConsentRequest: CustomerClientRequest;
  @Input() customerConsentResponse: CustomerClientResponse;
  @Input() brand: VehicleBrand
  @Output() didChange = new EventEmitter<void>();

  protected readonly ConsentStatus = ConsentStatus;

  getContactChannelIcon(contactChannel: ContactEvent, icon: 'checked' | 'unchecked') {
    const channelName = contactChannel.eventName as ContactChannelsKeys;
    const channelValue = this.customerConsentRequest[channelName];
    const iconMappings = {
      checked: {
        condition: channelValue === ConsentStatus.CONFIRMED,
        true: 'small-box-checked-green',
        false: 'small-box-checked-grey'
      },
      unchecked: {
        condition: channelValue === ConsentStatus.WITHDRAWN,
        true: 'small-box-unchecked-red',
        false: 'small-box-unchecked-grey'
      }
    };
    const mapping = iconMappings[icon];
    return mapping ? (mapping.condition ? mapping.true : mapping.false) : undefined;
  }

  change(contactChannel: ContactEvent, value: ConsentStatus) {
    const channelName = contactChannel.eventName as ContactChannelsKeys;
    this.customerConsentRequest[channelName] = value;
    this.didChange.emit();
  }
}
